import React from "react";

import Close from "../assets/svg/close.svg";
import { motion } from "framer-motion";
import { useAlert } from "react-alert";
import { connect } from "react-redux";

function SelectExercises(props) {
  const alert = useAlert();
  const { off, cat, exercises, profile } = props;
  if (JSON.parse(localStorage.getItem('isPremium')) === true) {
        profile.isPremium = true;
    }
  let selected = props.selected;
  //let quanti = selected.length;

  let refs = [];

  function basta() {
    off(false, selected);
  }
  function setRef(ref) {
    //console.log(ref.name);
    if (ref === null) {
      return;
    }
    refs[ref.name] = ref;
    refs[ref.name].checked = selected.includes(ref.name) ? true : false;
  }
  function setRef2(ref) {
    //console.log(ref.name);
    if (ref === null) {
      return;
    }
    refs["quanti"] = ref;
    refs["quanti"].innerHTML = selected.length;
  }

  function handleInputChange(event) {
    const target = event.target;
    const name = target.name;

    let removed = 0;
    for (let ex of selected) {
      if (name === ex) {
        refs[name].checked = false;

        let pos = selected.indexOf(name);
        //selected.remove(pos);
        //selected.slice(0, pos).concat(selected.slice(pos + 1));
        delete selected[pos];
        selected = selected.filter(function (a) {
          return typeof a !== "undefined";
        });
        removed = 1;
        break;
      }
    }

    if (removed === 0) {
      if (selected.length > 9) {
        alert.show("Vous pouvez sélectionner un maximum de 10 exercices par session.");
        event.preventDefault();
        return false;
      }

      refs[name].checked = true;
      selected.push(name);
    }

    // quanti = selected.length;
    //this.quanti.innerHTML = selected.length;
    refs["quanti"].innerHTML = selected.length;
  }

  const exercises_list =
    exercises && exercises.length
      ? exercises.map((exercise, index) => {
          //console.log(selected);
          return (
            <li
              className="listali"
              key={exercise.name}
              style={
                exercise.isPremium && !profile.isPremium
                  ? {
                      textDecoration: "none",
                      pointerEvents: "none",
                    }
                  : {}
              }
            >
              <div
                style={
                  exercise.isPremium && !profile.isPremium
                    ? { background: "rgba(255, 255, 255, 0.1)" }
                    : {}
                }
              >
                <input
                  type="checkbox"
                  id={"cb" + exercise.name}
                  name={exercise.name}
                  onClick={handleInputChange}
                  /*ref={this.selected[exercise.name]}*/
                  ref={setRef}
                />
                <label htmlFor={"cb" + exercise.name}>
                  <img
                    src={`https://cdn.fitzet.com/static%2F${exercise.name}.jpg?alt=media`}
                    alt={exercise.formatted}
                  />{" "}
                  <p style={{ textTransform: "capitalize" }}>
                    {exercise.formatted}{" "}
                    <font style={{ color: "#69C9D0" }}>
                      {exercise.isPremium ? "Premium" : null}
                    </font>
                  </p>
                </label>
              </div>
            </li>
          );
        })
      : null;

  return (
    <motion.div
      className="Yalla2"
      style={{
        background: "#EE1D52",
        padding: "20px 0px",
        position: "absolute",
        zIndex: 9999999,
        overflow: "hidden",
      }}
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", duration: 0.4 }}
    >
      <div style={{ float: "left", marginLeft: "10px", marginTop: "0px" }}>
        <span style={{ fontSize: "16px", fontWeight: 600 }}>
          <font style={{ color: "#69C9D0" }}>{cat.toUpperCase()}</font>{" "}
          EXERCISES - SELECTED{" "}
          <font style={{ color: "#69C9D0" }} ref={setRef2}></font> /10
        </span>
      </div>

      <div
        onClick={(e) => {
          if (selected.length !== 10) {
            alert.show("Please select 10 exercises!");
          } else {
            basta();
          }
        }}
        style={{ float: "right", marginRight: "10px" }}
      >
        <img src={Close} alt="close" style={{ maxHeight: "20px" }}></img>
      </div>
      <div style={{ height: "20px", overflow: "hidden" }}></div>
      <div
        style={{
          paddingTop: "10px",
          overflowY: "scroll",
          WebkitOverflowScrolling: "touch",
          height: "100%",
          width: "100%",
        }}
        className="yalla"
      >
        <ul className="listaul">{exercises_list}</ul>

        <p style={{ padding: "15px" }}>
          <button
            style={{
              fontSize: "18px",
              background: "#000",
              padding: "10px",
              border: 0,
              borderRadius: "4px",
              fontWeight: "600",
              width: "100%",
              color: "white",
            }}
            onClick={(e) => {
              if (selected.length !== 10) {
                alert.show("Veuillez sélectionner 10 exercices!");
              } else {
                basta();
              }
            }}
          >
            Done{" "}
            <span role="img" aria-label="aime">
              ✅
            </span>
          </button>
        </p>

        <div style={{ height: "260px" }}></div>
      </div>
    </motion.div>
  );
}

function mapStateToProps(state) {
  return { auth: state.firebase.auth, profile: state.firebase.profile };
}

export default connect(mapStateToProps, null)(SelectExercises);
